export function validatePassword(password){
  const missing = [];
  if(password.length < 8)          missing.push("at least 8 characters");
  if(!/[A-Z]/.test(password))      missing.push("one uppercase letter");
  if(!/[a-z]/.test(password))      missing.push("one lowercase letter");
  if(!/[0-9]/.test(password))      missing.push("one number");
  if(!/[^A-Za-z0-9]/.test(password)) missing.push("one special character");
  return missing; // empty array = valid
}
